module.exports = __webpack_public_path__ + "images/bug_yellow_large_20cd63a682cea231f498ec035ba1b754.png";